export const fetchYouTubeSubtitles = async (videoId: string, options: any) => {
    /*
	///used test personal key
	*/
    const apikey = "AIzaSyA0wyJuHTSjnXOMZrSVSsK4LIwwMA4neK4";
    /*
    const clientid = "934462210594-c2qadifkigf3p3r63ialks49k6qji96d.apps.googleusercontent.com";
    const redirecturi = "https%3A%2F%2Fshop.husky.co"; // + "%2Foauth2callback";
    const accessToken =
        "ya29.A0ARrdaM85qldv6eUQnFa5mcGJnQmhjjv82NgyM6lYkaZm0Q4Byd8UwBvU97w8mQ3rc8j4WQ0v2GY-Om5WbpWhQgiC-OLZf5fkgHl50tROgvFnwAzAEidNhSFt2tGSon6RSvVPrSNYcOK5zz1P28JBsem_Cgos";
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fyoutube.readonly&include_granted_scopes=true&state=state_parameter_passthrough_value&redirect_uri=${redirecturi}&response_type=token&client_id=${clientid}`;
    options = { baseUrl: "https://youtube.googleapis.com/youtube/v3/captions", ...(options || {}) };
    const requestUrl = `${options.baseUrl}?part=snippet&videoId=${videoId}&key=${apikey}&part=snippet&access_token=${accessToken}`;
	*/

    const requestUrl = `${options.baseUrl}?part=snippet&videoId=${videoId}&key=${apikey}&part=snippet`;
    const response = await fetch(requestUrl, {});

    if (response.ok) {
        return response.text().then(text => {
            try {
                const data = JSON.parse(text);
                const dataArray = data.items;
                let captionUrl = "";

                for (const [key, value] of Object.entries(dataArray)) {
                    if (dataArray[key].snippet.language === options.languageId) {
                        captionUrl = `https://www.googleapis.com/youtube/v3/captions/${dataArray[key].id}`;
                        // problem: needs authentification
                    }
                }

                // next step, extract transcript from captionUrl

                return data;
            } catch (err) {
                return [] as any;
            }
        });
    }
    return [] as any;
};
